export function CardHeader({ header }) {
  return (
    <h5 className="card-header">
      <strong>{header}</strong>
    </h5>
  );
}
